<template>
  <div class="content-container">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="hideRule ? {} : rules"
        :model="form"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="备注：" prop="note">
          <el-input
            v-model.trim="form.note"
            required
            maxlength="500"
            :rows="4"
            show-word-limit
            type="textarea"
            :placeholder="placeholder"
            class="input-field"
            @keydown.enter.native="handleTextareaKeydown"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入备注信息'
    }
  },
  data() {
    return {
      dialogVisible: false,
      hideRule: false,
      form: {
        note: ''
      },
      rules: {
        note: [{ required: true, message: '请输入备注信息', trigger: 'blur' }]
      },
      loading: false,
      operateType: 1 // 操作类型
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 限制输入框换行操作
    handleTextareaKeydown() {
      const e = window.event || arguments[0]
      if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
        e.returnValue = false
        return false
      }
    },
    openDialog(hideRule) {
      this.hideRule = hideRule
      this.dialogVisible = true
    },
    handleClose(done) {
      console.log('handleClose')
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    submit() {
      switch (this.title) {
        case '超管终止':
          this.operateType = 1
          break
        case '批量通过':
          this.operateType = 2
          break
        case '批量驳回':
          this.operateType = 3
          break
        case '撤回':
          this.operateType = 4
          break
        case '审阅':
          this.operateType = 5
          break
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$emit('submitForm', this.operateType, this.form, () => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/views/taskManage/css/dialog.scss";

// .el-textarea{
//   padding-right: 55px;
// }
// /deep/.el-input__count{
//   bottom: -11px;
//   right: 0;
// }
.el-button{
  min-width:72px;
  height:32px;
  padding: 0 15px;
}
</style>
